export class StringHelper {
  public static getLastSegment(value: string) {
    const segments = value.split('.');
    return segments[segments.length - 1];
  }
}
